import React from "react";
import Contact from "../../components/contact/Contact";
import Footer from "../../components/layout/footer/Footer";
import Navbar from "../../components/layout/header/Navbar";
import Layout from "../../components/layout/Layout";
import Subsribe from "../../components/newsletter/Subsribe";
import PageHeader from "../../components/team/PageHeader";
import Teams from "../../components/team/Teams";

export default function OurTeam({ information }) {
  return (
    <Layout>
      <Navbar darkBg information={information} />
      <PageHeader HeaderTitle="Our Team" Parent="Our Team" />
      <Teams />
      <Contact information={information} bgColor="gray-light-bg" />
      {/* <Subsribe /> */}
      <Footer space information={information} />
    </Layout>
  );
}
